<nb-card>
  <nb-card-header>گزارش گیری</nb-card-header>
  <nb-card-body>
    <form (ngSubmit)="page = 1;getUserList()">
      <div class="row">
        <div class="col-4 mb-3">
          <input name="phone" class="right-placeholder" type="number" dir="auto" fullWidth [(ngModel)]="phoneFilter" nbInput
                 placeholder="شماره تلفن">
        </div>
        <div class="col-4 mb-3">
          <input name="email" class="right-placeholder" type="email" dir="auto" fullWidth nbInput [(ngModel)]="emailFilter"
                 placeholder="ایمیل">
        </div>
        <div class="col-4 mb-3">
          <input name="firstname" class="right-placeholder" type="text" dir="auto" fullWidth nbInput [(ngModel)]="firstNameFilter"
                 placeholder="نام">
        </div>
        <div class="col-4 mb-3">
          <input name="lastname" class="right-placeholder" type="text" dir="auto" fullWidth nbInput [(ngModel)]="lastNameFilter"
                 placeholder="نام خانوادگی">
        </div>

        <div class="col-4 mb-3">
          <input name="nationalid" class="right-placeholder" dir="auto" fullWidth nbInput [(ngModel)]="nationalIDFilter"
                 placeholder="کد ملی">
        </div>
        <div class="col-4 mb-3">
          <nb-select [(ngModel)]="kycStatusFilter" fullWidth placeholder="وضعیت احراز">
            <nb-option [value]="null">همه کاربران</nb-option>
            <nb-option [value]="'COMPLETED'">احراز کامل به همراه عکس یا ویدیو سلفی</nb-option>
            <nb-option [value]="'NATIONAL_ID_VERIFIED'">احراز اطلاعات ثبت احوال</nb-option>
            <nb-option [value]="'PHONE_VERIFIED'">احراز شماره تلفن</nb-option>
            <nb-option [value]="'NOT_COMPLETED'">احراز نشده (کاربران دارای ایمیل)</nb-option>
          </nb-select>
        </div>
        <div class="col-4 mb-3">
          <button nbButton type="submit"  [nbSpinner]="tableLoading" [disabled]="tableLoading"
                  status="primary">
            گزارش‌گیری
          </button>
        </div>
      </div>
    </form>
  </nb-card-body>
</nb-card>
<nb-card>
  <nb-card-header>
    <div class="d-flex align-items-center justify-content-between">
      <div class="d-flex align-items-center">
        لیست کاربران
      </div>

      <button nbButton size="small" (click)="openDownloaDialog()" status="primary">
        <i class="fal fa-download ms-2"></i>
        <span>اکسل کاربران احراز هویت نشده</span>
      </button>
    </div>
  </nb-card-header>
  <nb-card-body>
    <div class="d-flex align-items-center justify-content-between mb-2">
      <nb-select
        class="ms-2"
        [selected]="25"
        (selectedChange)="changeRecordPerPageLimit($event)"
        placeholder="تعداد نمایش"
      >
        <nb-option [value]="10">10</nb-option>
        <nb-option [value]="15">15</nb-option>
        <nb-option [value]="25">25</nb-option>
        <nb-option [value]="50">50</nb-option>
        <nb-option [value]="100">100</nb-option>
      </nb-select>
    </div>
    <div class="position-relative">
      <p-table
        #PtableComponent
        [value]="pagination.data"
        [tableStyleClass]="'table text-center   stacked-table table-hover'"
        [lazy]="true"
        [alwaysShowPaginator]="false"
        (onPage)="changePage($event)"
        [autoLayout]="true"
        [paginator]="true"
        [rows]="recordPerPage"
        [totalRecords]="pagination.totalRecords"
        [loading]="tableLoading"
      >
        <ng-template pTemplate="header">
          <tr>
            <th>شناسه</th>
            <th *ngIf="checkScope('OR', 'admin:edit:user',
        'admin:view:user:transactions',
        'admin:view:users:ibans',
        'admin:view:orders:fee',
        'admin:view:users:credit_cards')">یادداشت
            </th>
            <th *ngIf="checkScope('AND', 'admin:create:notification:single_user')">اطلاعیه</th>
            <th>نام و نام خانوادگی</th>
            <th>شماره تلفن</th>
            <th>ایمیل</th>
            <th>کدملی</th>
            <th>تاریخ ثبت نام</th>
            <th>تاریخ تولد</th>
            <th>کد دعوت شده</th>
            <th>جنسیت</th>
            <th>اطلاعات احراز کاربر</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-user>
          <tr>
            <td><code class="text-basic">{{ user.id }}</code></td>
            <td *ngIf="checkScope('OR', 'admin:edit:user',
        'admin:view:user:transactions',
        'admin:view:users:ibans',
        'admin:view:orders:fee',
        'admin:view:users:credit_cards')">
              <button (click)="note(user)" nbButton status="info" ghost>
                <i class="fal fa-sticky-note position-relative fa-2x" title="note"></i>
              </button>
            </td>
            <td *ngIf="checkScope('AND', 'admin:create:notification:single_user')">
              <button (click)="notification(user)" nbButton status="warning" ghost>
                <i class="fal fa-bell  position-relative fa-2x" title="edit"></i>
              </button>
            </td>
            <td>
              <div class="d-flex align-items-center">
                <div style="width: 65px">
                  <ng-container *ngIf="user.faceImagePath;else DefaultImage">
                    <img class="report-avatar" [src]="user.faceImagePath" appSecureImage />
                  </ng-container>
                  <ng-template #DefaultImage>
                    <img class="report-avatar" src="https://cdn.nesoex.com/assets/user.png" />
                  </ng-template>
                </div>
                <a
                  *ngIf="checkScope(
                  'OR',
                  'admin:view:user:transactions',
                  'admin:edit:user',
                  'admin:view:users:ibans',
                  'admin:view:orders:fee',
                  'admin:view:users:credit_cards'
                );else DefaultName"
                  class="text-primary text-align-right"
                  [routerLink]="user?.id ? '/dashboard/user/' + user?.id : null"
                >

                  {{
                    user?.firstName || user?.lastName
                      ? user.firstName + ' ' + user.lastName
                      : '-'
                  }}
                </a>
                <ng-template #DefaultName>
                  {{
                    user?.firstName || user?.lastName
                      ? user.firstName + ' ' + user.lastName
                      : '-'
                  }}
                </ng-template>
              </div>
            </td>
            <td>
              <a
                *ngIf="checkScope(
                  'OR',
                  'admin:view:user:transactions',
                  'admin:edit:user',
                  'admin:view:users:ibans',
                  'admin:view:orders:fee',
                  'admin:view:users:credit_cards'
                );else DefaultPhone"
                class="text-primary"
                [routerLink]="user?.id ? '/dashboard/user/' + user?.id : null"
              >
                <bdi class="text-primary no-wrap">{{
                    user.phone ? user.phone : '-'
                  }}
                </bdi>
              </a>
              <ng-template #DefaultPhone>
                <bdi class="text-basic no-wrap">{{
                    user.phone ? user.phone : '-'
                  }}
                </bdi>
              </ng-template>
            </td>
            <td>
              <a
                *ngIf="checkScope(
                  'OR',
                  'admin:view:user:transactions',
                  'admin:edit:user',
                  'admin:view:users:ibans',
                  'admin:view:orders:fee',
                  'admin:view:users:credit_cards'
                );else DefaultPhone"
                class="text-basic"
                [routerLink]="user?.id ? '/dashboard/user/' + user?.id : null"
              >
                <code class="text-basic">{{
                    user.email ? user.email : '-'
                  }}
                </code>
              </a>
              <ng-template #DefaultPhone>
                <code class="text-basic">{{
                    user.email ? user.email : '-'
                  }}
                </code>
              </ng-template>
            </td>
            <td>
              {{ user.nationalId }}
            </td>
            <td>
              {{ user.createdAt | dateFormat : 'HH:mm jYYYY/jMM/jDD' }}
            </td>
            <td>
              {{ user.birthday ? (user.birthday | dateFormat : 'jYYYY/jMM/jDD') : '-' }}
            </td>
            <td>
              <code class="text-danger">{{ user.referralCode }}</code>
            </td>
            <td>
              {{ user.gender === 'male' ? 'مرد' : user.gender === 'female' ? 'زن' : '-' }}
            </td>
            <td>
              <button (click)="openKYCImagesModal(user)" status="info" nbButton>احراز هویت</button>
            </td>
          </tr>
        </ng-template>

      </p-table>
    </div>

  </nb-card-body>
</nb-card>

<ng-template #downloadDialog let-context>
  <nb-card class="download-dialog">
    <nb-card-header>
      <span class="d-flex align-items-center">
        <i class="fal fa-download ms-2"></i>
        <span>دانلود اکسل کاربران احراز هویت نشده</span>
      </span>
    </nb-card-header>

    <nb-card-body class="download-dialog__body">
      <div class="row">
        <div class="col-6">
          <label class="d-flex mb-2">تاریخ شروع</label>
        </div>
        <div class="col-6">
          <label class="d-flex mb-2">تاریخ پایان</label>
        </div>
      </div>

      <div class="row align-items-center mb-3">
        <div class="col-6">
          <app-datepicker [minYear]="1402" [now]="true" (dateSelected)="setStart($event)"></app-datepicker>
        </div>
        <div class="col-6">
          <app-datepicker [minYear]="1402" [now]="true" (dateSelected)="setEnd($event)"></app-datepicker>
        </div>
      </div>
    </nb-card-body>

    <nb-card-footer class="download-dialog__footer">
      <button nbButton (click)="closeDownloadDialog()" [disabled]="generatingExcel">انصراف</button>
      <button nbButton (click)="generateUsersCSV()" status="primary"
              [disabled]="!downloadStartDate || !downloadEndDate || generatingExcel" [nbSpinner]="generatingExcel">
        <i class="fal fa-download ms-2"></i>
        <span>دانلود</span>
      </button>
    </nb-card-footer>
  </nb-card>
</ng-template>
<ng-template #KYCImageModal let-ref="dialogRef">
  <nb-card style="max-height: 900px">
    <nb-card-header>
      <div class="d-flex align-items-center justify-content-between">
        <span>اطلاعات احراز کاربر</span>
        <button nbButton ghost (click)="ref.close()"><i class="fas fa-times"></i></button>
      </div>
    </nb-card-header>
    <nb-card-body>
      <div class="d-flex align-items-center gap-3">
        <nb-card style="height: 500px" *ngIf="selectedUser.nationalCardImage">
          <nb-card-header>تصویر کارت ملی</nb-card-header>
          <nb-card-body>
            <img width="400" [src]="selectedUser.nationalCardImage" appSecureImage />
          </nb-card-body>
        </nb-card>
        <nb-card style="height: 500px" *ngIf="selectedUser.identityImage || selectedUser.identityVideo">
          <nb-card-header>عکس یا ویدیوی سلفی</nb-card-header>
          <nb-card-body>
            <div class="d-flex align-items-center gap-1">
              <img width="400" *ngIf="selectedUser.identityImage" [src]="selectedUser.identityImage" appSecureImage />
              <video width="400" controls *ngIf="selectedUser.identityVideo" [src]="selectedUser.identityVideo"
                     appSecureVideo></video>
            </div>
          </nb-card-body>
        </nb-card>
      </div>
    </nb-card-body>
  </nb-card>
</ng-template>
